import type { Xinglet, XingletClass } from '@xing-com/crate-xinglet';
import type { Runtime } from '@xing-com/crate-xinglet/internal';

export function createXinglet(
  xingletClass: XingletClass,
  name: string,
  runtime: Runtime
): Xinglet {
  const { host } = runtime;

  const xinglet: Xinglet = Object.assign(new xingletClass(host), {
    name,
  });

  xinglet.createContexts?.(host.provideContext(name));

  return xinglet;
}
